import { render } from "./KatudoMosikomiConfirm.vue?vue&type=template&id=6836c02e"
import script from "./KatudoMosikomiConfirm.vue?vue&type=script&lang=js"
export * from "./KatudoMosikomiConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\作業\\GitlabWebシステム\\ｱ_青森市社会福祉協議会_Webボランティアシステム\\Web-Volunteer-Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__